import Box from '@risk-smart/themed-cloudscape-components/box';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  /** Widget-specific copy; the generic "No data available" when omitted. */
  title?: string;
  body?: string;
};

export const NoWidgetData: FC<Props> = ({ title, body }) => {
  const { t } = useTranslation(['common'], { keyPrefix: 'dashboard' });

  return (
    <div
      className={'flex items-center justify-center h-full'}
      data-testid={'no-widget-data'}
    >
      <Box textAlign={'center'}>
        <b>{title ?? t('no_data_title')}</b>
        <Box variant={'p'}>{body ?? t('no_data_body')}</Box>
      </Box>
    </div>
  );
};
